import { instanceConexao } from "services/axiosServices";
import { AxiosRequestConfig } from "axios";

interface Params {
  authToken: string;
  idAutonomo: string;
  idsRevendaEmpreendimento: string[];
  registros: number;
  pagina: number;
}

/**
 * Função para retornar unidades da revenda por autônomo
 *
 * @param {Params} params - Parâmetros para listagem.
 * @param {string} params.authToken - Token de autenticação do usuário.
 * @param {string} params.idAutonomo - ID do autônomo.
 * @param {string[]} params.idsRevendaEmpreendimento - IDs dos empreendimentos da revenda.
 * @param {number} params.registros - Quantidade de registros a serem retornados.
 * @param {number} params.pagina - Número da pagina a ser retornada.
 * @returns {Promise<any>} - Resposta da API.
 */
export const postUnidadeAutonomo = async (params: Params): Promise<any> => {
  const url = "/api/RevendaUnidade/ListarRevendaUnidadePorAutonomo";
  const { authToken, ...parameters } = params;
  const config: AxiosRequestConfig = {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  };
  const response = await instanceConexao.post(url, parameters, config);
  return response?.data;
};
